import store from '@/store'
import * as Constants from '@/lib/constants'

export default class StripeInfo {
  static get() {
    return store.getters.stripeInfo
  }

  static getPublishableKey() {
    const stripeInfo = StripeInfo.get()
    if (stripeInfo) {
      return stripeInfo.publishableKey
    }
    return null
  }

  static getCards() {
    const stripeInfo = StripeInfo.get()
    if (stripeInfo) {
      return stripeInfo.cards
    }
    return []
  }

  static getDefaultCard() {
    return StripeInfo.getCards().find(card => card.defaultCard)
  }

  static getCurrency() {
    const stripeInfo = StripeInfo.get()
    if (stripeInfo) {
      return stripeInfo.currency
    }
    return null
  }

  static isChargeAutomatically(billingPlans) {
    const stripeInfo = StripeInfo.get()
    if (stripeInfo) {
      // stripeInfo.purchasesには現在契約中の複数プラン情報が入っている
      for (let iPurchasesCnt = 0; iPurchasesCnt < stripeInfo.purchases.length; iPurchasesCnt++) {
        // billingPlansには契約プランの中から探したいプラン情報が入っている
        for (let iBillingPlansCnt = 0; iBillingPlansCnt < billingPlans.length; iBillingPlansCnt++) {
          // 該当のプランを探し、カード払いか請求書払いかを判定する
          // 支払い方法はsubscriptionごと設定される
          if (stripeInfo.purchases[iPurchasesCnt].planId === billingPlans[iBillingPlansCnt].id) {
            return (
              stripeInfo.purchases[iPurchasesCnt].collectionMethod ===
              Constants.StripeCollectionMethod.ChargeAutomatically
            )
          }
        }
      }
    }
    return false
  }
}
